module.exports = __webpack_public_path__ + "media/images/icons/mailaddress-17c00538367042ae782659adef339742.svg";